import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

function safeSetTag(tag: string, value: string | undefined): void {
  try {
    Sentry.setTag(tag, value)
  } catch {
    // Sentry SDK uninitialized — defensive no-op
  }
}

export function useSentryExperimentTag(flagKey: string, variant?: string | null): void {
  useEffect(() => {
    if (variant == null) return
    const tag = `gb_${flagKey}`
    safeSetTag(tag, variant)
    return () => safeSetTag(tag, undefined)
  }, [flagKey, variant])
}
